var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgGoogle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 10.2272C19.9998 9.51808 19.9349 8.83627 19.8143 8.18173H10.204V12.0499H15.6956C15.459 13.2999 14.7401 14.3589 13.6594 15.068V17.5771H16.9572C18.8867 15.8362 19.9998 13.2726 19.9998 10.2272Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.204 19.9997C12.9591 19.9997 15.2689 19.1044 16.9572 17.5771L13.6594 15.068C12.7457 15.668 11.5769 16.0225 10.204 16.0225C7.54633 16.0225 5.29681 14.2634 4.4944 11.8998H1.08534V14.4907C2.76436 17.7588 6.21517 19.9997 10.204 19.9997Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4944 11.8998C4.29032 11.2998 4.17436 10.659 4.17436 9.99989C4.17436 9.34081 4.29032 8.6999 4.4944 8.09991V5.50903H1.08533C0.394245 6.85901 0 8.38627 0 9.99989C0 11.6135 0.39425 13.1407 1.08534 14.4907L4.4944 11.8998Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.204 3.97717C11.7021 3.97717 13.0472 4.48171 14.1047 5.47261L17.0314 2.60446C15.2643 0.990838 12.9544 -6.10352e-05 10.204 -6.10352e-05C6.21517 -6.10352e-05 2.76436 2.24088 1.08533 5.50903L4.4944 8.09991C5.2968 5.7363 7.54633 3.97717 10.204 3.97717Z",
    fill: "#EA4335"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google.70f16564c58fbd62354c2cec763a05f3.svg";